import script from "./main.vue?vue&type=script&setup=true&lang=js"
export * from "./main.vue?vue&type=script&setup=true&lang=js"

import "./main.vue?vue&type=style&index=0&id=33017b13&lang=css"

const __exports__ = script;

export default __exports__